// @flow
// pass types
export const ADULT_YOUTH_PASS = 1
export const INTERAGENCY_PASS = 2
export const SENIOR_PASS = 3
export const LOCAL_PASS = 4
export const ADULT_PASS = 5
export const YOUTH_PASS = 6
